import { Typography, Box } from "@mui/material";
import { Container } from "@mui/system";
import CustomSection from "components/CustomSection";
import ScrollTransition from "components/ScrollTransition";
import AppCard from "./AppCard";
import styles from "./styles.module.css";

const Download = ({ dark_mode }) => {
  const logoSrc = dark_mode
    ? require("../../../../assets/static/logo/main_white.png")
    : require("../../../../assets/static/logo/main_black.png");

  return (
    <CustomSection
      style={{
        overflow: "hidden",
      }}
      id="download"
      bg_color="var(--background-color0)"
    >
      <Container
        maxWidth="xl"
        sx={{
          width: "100vw",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "1rem",
        }}
      >
        <Box sx={{ textAlign: "center", marginBottom: "2rem" }}>
          <ScrollTransition>
            <Box sx={{ marginBottom: "2rem", display: "flex", justifyContent: "center" }}>
              <img
                src={logoSrc}
                alt="iGooB Logo"
                className="Transition-1"
                style={{ width: "14rem", height: "auto" }}
              />
            </Box>
          </ScrollTransition>

          <ScrollTransition>
            <Typography
              variant="h2"
              className={styles.title}
            >
              Baixe o <span>iGooB</span>
            </Typography>
          </ScrollTransition>

          <ScrollTransition>
            <Typography className={styles.subtitle}>
              Disponível para iOS e Android. Escolha a versão que melhor atende suas necessidades.
            </Typography>
          </ScrollTransition>
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "2rem",
            width: "100%",
            maxWidth: "900px",
            margin: "3rem auto 0",
          }}
        >
            <AppCard
              variant="default"
              title="Para Você"
              description="Encontre os melhores serviços e produtos na palma da sua mão."
              features={[
                "Pedidos rápidos e fáceis",
                "Acompanhe em tempo real",
                "Pagamento seguro"
              ]}
            />
            <AppCard
              variant="entregador"
              title="Para Entregadores"
              description="Seja seu próprio chefe e ganhe dinheiro no seu tempo."
              features={[
                "Flexibilidade de horários",
                "Ganhos transparentes",
                "Rotas otimizadas"
              ]}
            />
        </Box>
      </Container>
    </CustomSection>
  );
};

export default Download;
